import { useLanguage } from '../../../../contexts/LanguageContext';

export const formatDate = (dateString) => {
  if (!dateString) return '不適用';
  try {
    const date = new Date(dateString);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  } catch {
    return dateString;
  }
};

export const formatTime = (timeString) => {
  if (!timeString) return '不適用';
  try {
    if (typeof timeString === 'string') {
      // if "HH:MM:SS" format -> HH:MM
      if (timeString.includes(':')) {
        const parts = timeString.split(':');
        return `${parts[0]}:${parts[1]}`;
      }
    }

    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  } catch {
    return timeString;
  }
};

// HKT 時間格式化函數
export const formatTimeFromHKT = (hktTimeStr) => {
  if (!hktTimeStr) return '不適用';
  try {
    if (hktTimeStr.includes('T') && hktTimeStr.includes('+08:00')) {
      const timePart = hktTimeStr.split('T')[1].split('+')[0]; // 取得 "09:30:00"
      const [hours, minutes] = timePart.split(':');
      return `${hours}:${minutes}`;
    }

    const date = new Date(hktTimeStr);
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  } catch {
    return hktTimeStr;
  }
};

export const formatDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return '不適用';
  try {
    const date = new Date(dateTimeStr);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  } catch {
    return dateTimeStr;
  }
};

export const formatPhone = (phoneStr) => {
  if (!phoneStr) return '不適用';
  if (phoneStr.startsWith('+852')) {
    return phoneStr.replace('+852', '+852 ');
  }
  return phoneStr;
};

export const getGenderText = (gender) => {
  switch (gender?.toLowerCase()) {
    case 'male':
      return '男';
    case 'female':
      return '女';
    default:
      return gender || '不適用';
  }
};

export const getPatientTypeText = (type) => {
  switch (type) {
    case 'New Patient':
      return '新病人';
    case 'Follow Up':
      return '覆診';
    default:
      return type || '不適用';
  }
};

export const getLanguageText = (lang) => {
  switch (lang) {
    case 'zh_HK':
      return '繁體中文';
    case 'en':
      return 'English';
    default:
      return lang || '不適用';
  }
};

export const hasValidContent = (value) => {
  return value && value !== '' && value !== '-' &&
    value !== 'symptom description or null' &&
    value !== 'special request or null';
};

// 時間範圍格式化函數
export const formatTimeRange = (startTime, endTime) => {
  if (!startTime) return '不適用';

  const formattedStartTime = formatTime(startTime);

  if (!endTime) {
    return formattedStartTime;
  }

  const formattedEndTime = formatTime(endTime);
  return `${formattedStartTime} - ${formattedEndTime}`;
};
